module.exports = __webpack_public_path__ + "static/media/web logos_Brunel_colour.7f5ce190.jpg";